import { styles } from './UiProductInfoUsageInstructions.styles';

export interface UiProductInfoUsageInstructionsProps {
  instructions: string;
}

export function UiProductInfoUsageInstructions({
  instructions
}: UiProductInfoUsageInstructionsProps) {
  const slots = styles();
  return (
    <div className={slots.base()}>
      <div
        className={slots.content()}
        dangerouslySetInnerHTML={{ __html: instructions }}
        suppressHydrationWarning
      />
    </div>
  );
}
